<template>
    <div :class="{['add-user-popup'] :true, ['hide'] : !display}">
        <div class="popup" ref="addUserPopupRef">
            <div class="title-section">
                <h2>{{ $t("dash.settings.users.header.add_user") }}</h2>
                <p>{{ $t('dash.settings.add_user.subtitle').replace('%',stateCarrousel) }}</p>
            </div>

            <div class="container-carrousel">
               
                <div :class="'carrousel state' + stateCarrousel">
                    <div class="slide slide1">
                        <div class="container-input name">

                            <div class="inputs">
                                <div class="container-input">
                                    <label>{{ $t('dash.settings.add_user.firstname.label') }}</label>
                                    <div class="input">
                                        <i class="fa-regular fa-circle-user"></i>
                                        <input :placeholder="$t('dash.settings.account.name.first_name.placeholder')" v-model="form.firstname">
                                        <div class="containerError" v-if="error.firstname ">
                                            <Tooltip :position="'top'" :text="error.firstname">
                                                <i class="fa-regular fa-circle-exclamation"></i>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                               
                                <div class="container-input">
                                    <label>{{ $t('dash.settings.add_user.lastname.label') }}</label>
                                    <div class="input">
                              
                                        <input :placeholder="$t('dash.settings.account.name.last_name.placeholder')" v-model="form.lastname">

                                        <div class="containerError" v-if="error.lastname ">
                                            <Tooltip :position="'top'" :text="error.lastname">
                                                <i class="fa-regular fa-circle-exclamation"></i>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>

                               

                               
                            </div>
                        </div>

                        <div class="container-input email">
                            <label>{{ $t("dash.settings.account.email.title") }}</label>
                            <div class="input">
                                <i class="fa-regular fa-at"></i>
                                <input placeholder="Entrez une adresse Email" v-model="form.email">
                                <div class="containerError" v-if="error.email ">
                                    <Tooltip :position="'top'" :text="error.email">
                                        <i class="fa-regular fa-circle-exclamation"></i>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>

                        <div class="container-input pasword">
                            <label>{{ $t("dash.settings.account.password.title") }}</label>
                        
                            <div class="input">
                                <i class="fa-regular fa-key"></i>
                                <input :placeholder="$t('dash.settings.add_user.password.placeholder')" v-model="form.password">
                                <div class="containerError" v-if="error.password ">
                                    <Tooltip :position="'top'" :text="error.password">
                                        <i class="fa-regular fa-circle-exclamation"></i>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="slide slide2">
                        <div class="container-input role">
                            <label>{{ $t("dash.settings.users.legend.role") }}</label>
                            <div class="input">
                                <SelectComponent :changeValueSelect="changeRole" :data="getDataSelectRole()" :valueSelect="form.role" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
                            </div>
                        </div>

                        <div class="container-input notifications">
                            <label>{{ $t('dash.settings.add_user.notifications.title') }}</label>
                            <div class="box">
                                <div class="notification" v-if="form.role !== 'Viewer'">
                                    {{ $t('dash.settings.add_user.notifications.echec.description') }}.
                                    <ComponentSwitch :value="form.alertEchec" :onChange="handleChangeAlert" :id="'alertEchec'"></ComponentSwitch>
                                </div>
                                <div class="notification">
                                    <span v-html="$t('dash.settings.add_user.notifications.validation.description')"></span>
                                    <ComponentSwitch :value="form.alertValidation" :onChange="handleChangeAlert" :id="'alertValidation'"></ComponentSwitch>
                                </div>
                                <div class="notification" v-if="form.role !== 'Viewer'">
                                    <span v-html="$t('dash.settings.add_user.notifications.inbox.description')"></span>
                                    <ComponentSwitch :value="form.alertInbox" :onChange="handleChangeAlert" :id="'alertInbox'"></ComponentSwitch>
                                </div>
                                <div class="notification" v-if="form.role !== 'Viewer'">
                                    <span v-html="$t('dash.settings.add_user.notifications.page.description')"></span>
                                    <ComponentSwitch :value="form.alertPage" :onChange="handleChangeAlert" :id="'alertPage'"></ComponentSwitch>
                                </div>
                                <div class="notification" v-if="form.role !== 'Viewer'">
                                    <span v-html="$t('dash.settings.add_user.notifications.source.description')"></span>
                                    <ComponentSwitch :value="form.alertSource" :onChange="handleChangeAlert" :id="'alertSource'"></ComponentSwitch>
                                </div>
                                <!-- <p class="info">{{ $t('dash.settings.add_user.notifications.description') }}</p> -->
                            </div>
                        </div>
                    </div>

                    <div class="slide slide3">
                        <div class="container-select-page">
                            <SelectPageComponenent 
                            :groups="groups" 
                            :allPages="allPages" 
                            :SelectPageProp="SelectPage.reduce((acc, id) => { allPages[id] && acc.push(allPages[id]); return acc }, [])" 
                            v-on:updateSelectPage="updateSelectPage"
                        ></SelectPageComponenent>
                        </div>
                        <div class="list-page-select hide-scrollbar">
                            <p>{{ $t('dash.settings.add_user.page_select') }}</p>
                            <div class="list-avatar">
                                <Tooltip v-for="pageId in SelectPage.filter(p => findPage(p))" :position="'top'" :text="findPage(pageId).name" :key="pageId">
                                    <Avatar :checked="true"  :id="pageId" :urlPicture="findPage(pageId).avatar" :typeNetwork="findPage(pageId).network" v-on:click="removeSelectPage" :key="pageId"></Avatar>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btns">
                <div class="btn-outline-primary" @click="previousStade" v-if="stateCarrousel > 1">{{ $t('dash.settings.add_user.previous') }}</div>
                <div class="btn-outline-primary" @click="cancel" v-else>{{ $t('dash.settings.add_user.cancel') }}</div>

                <div class="btn-primary icon-r" @click="nextState" v-if="stateCarrousel < 3">{{ $t('dash.settings.add_user.next') }}</div>
                <div class="btn-primary icon-r" @click="save" v-else>{{ $t('dash.settings.add_user.save') }}</div>
            </div>
          
        </div>
    </div>
</template>

<script>

import ComponentSwitch from './../utils/switch.vue'
import Avatar from './../utils/avatar.vue'
import SelectPageComponenent from './../SelectPage.vue'
import SelectComponent from './../utils/select.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
    name: 'addUserPopup',

    components : {
        ComponentSwitch,
        SelectPageComponenent,
        Avatar,
        SelectComponent,
        Tooltip
    },

    props:{
        
        display : Boolean,
        pages_access : Array,
        groups : Array,
        roles : Array,
        data : Object,
        
        stateCarrouselDefault: {
            type : Number,
            default : 1
        },

        isAdmin : {
            type : Boolean,
            default : false
        },

        emailExist : Function,
        
    },
    data() {
        return {
            form : {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
                role: 'Editor',
                alertEchec : false,
                alertValidation : true,
                alertInbox : false,
                alertPage : false,
                alertSource : false
            },

            SelectPage : [],

            error : {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
            },
            stateCarrousel : 1

        };   
    },
    
    mounted() {
        console.log('mounted')
        window.addEventListener('click', this.handleClickOutside);

        if (this.data && this.data.form) {
            this.form = {...this.form,...this.data.form}
        }

        if (this.data && this.data.selectPage) {
            this.SelectPage = this.data.selectPage
        }

        this.stateCarrousel = this.stateCarrouselDefault
    },



    methods: {
        changeRole(value) {
            this.form.role = value
        },

        handleChangeAlert(value,type) {
           this.form[type] = value
        },

        updateSelectPage(selectPage) {
            this.SelectPage = selectPage
        },

        getDataSelectRole() {
            const dataRole = {Viewer: this.$t("dash.settings.user.Viewer") ,Writter: this.$t("dash.settings.user.Writter"),Editor: this.$t("dash.settings.user.Editor"), Admin: this.$t("dash.settings.user.Administrator")}
            
            let newData = {};
            let indexMaxRoles = null

            if (this.isAdmin) {
                indexMaxRoles = 3
            }else if(!this.roles || this.roles.length == 0) {
                indexMaxRoles = 2
            }else{
                this.roles.forEach(role => {
                    let index = Object.keys(dataRole).indexOf(role)
                    if (index !== -1 && (indexMaxRoles == null || index > indexMaxRoles)) {
                        indexMaxRoles = index
                    }
                });
            }

            if (indexMaxRoles !== null) {
                const dataRoleEntries = Object.entries(dataRole)
                for (let i = 0; i <= indexMaxRoles; i++) {
                    newData[dataRoleEntries[i][0]] = dataRoleEntries[i][1]
                }
            }
                
            return newData
        },

        cancel(){
            // this.form = {
            //     firstname : '',
            //     lastname: '',
            //     email:'',
            //     password:'',
            //     role: 'viewer',
            //     alertEchec : true,
            //     alertValidation : true,
            //     alertPage : true,
            //     alertSource : true
            // },

            // this.error = {
            //     firstname : '',
            //     lastname: '',
            //     email:'',
            //     password:'',
            // }
            // this.stateCarrousel = 1;
       
            this.$emit('closePopUp')
        },

        nextState(){
           
            this.error = {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
            }

            let isSuccess = true;

            switch (this.stateCarrousel) {
                case 1:
                    if (this.form.lastname == "") {
                        isSuccess = false;
                        this.error.lastname = this.$t('dash.settings.add_user.error.last_name_required')
                    }

                    if (this.form.firstname == "") {
                        isSuccess = false;
                        this.error.firstname = this.$t('dash.settings.add_user.error.first_name_required')
                    }

                    if (this.form.email == "") {
                        isSuccess = false;
                        this.error.email = this.$t('dash.settings.add_user.error.email_required')

                    }else if (!this.data || !this.data.form ||  !this.data.form.email || this.data.form.email !== this.form.email) {   //nouvelle adresse ?
                        if (!(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.form.email))) { // eslint-disable-line
                            isSuccess = false;
                            this.error.email = this.$t('dash.settings.add_user.error.email_invalid')
                        } else if(this.emailExist(this.form.email)) {
                            isSuccess = false;
                            this.error.email = this.$t('dash.settings.add_user.error.email_exist')
                        }
                    }

                    if (!this.data && this.form.password == "") {
                        isSuccess = false;
                        this.error.password = this.$t('dash.settings.add_user.error.password_required')
                    }

                    if (isSuccess) {
                        this.stateCarrousel++
                    }
                break;
            
                case 2:
                    this.stateCarrousel++
                    break;

            }



        },

        previousStade() {
            if (this.stateCarrousel > 1) {
                this.stateCarrousel--;
            }
        },

        findPage(pageId) {
            let page = this.pages_access.find(p => p.id == pageId)
            return page && page ? page : null
        },

        removeSelectPage(e,idPage) {
            e.stopPropagation()
            this.SelectPage = this.SelectPage.filter(id => id !== idPage)
        },

        async save(){
          
            this.$emit('submit', {
                firstname : this.form.firstname,
                lastname: this.form.lastname,
                email: this.form.email,
                password: this.form.password,
                role: this.form.role,
                alertEchec : this.form.alertEchec,
                alertValidation : this.form.alertValidation,
                alertInbox : this.form.alertInbox,
                alertPage : this.form.alertPage,
                alertSource : this.form.alertSource,
                selectPage: this.SelectPage,
            })
            // this.cancel()
        },

        handleClickOutside(event) {
            return //disable pour le moment
            // if (!this.$refs.addUserPopupRef.contains(event.target)) {
            //     window.removeEventListener("click", this.handleClickOutside, false);
            //     this.cancel()
            // }
        },

    },

    computed: {
        allPages() {
            return this.pages_access.reduce((acc, page) => {
                acc[page.id] = page
                return acc
            },{})
        }
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>

